export const regexps = {
  localeCode: /^(([a-z]{2})-[a-z]{2})$/i,
  localeLangCode: /^(([a-z]{2}))$/i,
};
